// @flow
import React from "react";
import { noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";
import Icon from "@fdr/static-ui/Icons";
import { arrowDown } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";

import { Container, Text } from "./styled-components";

type Props = {
  raceNumber: string,
  openTrackSelector: NullaryFn<void>,
  trackSelectorUrl: string,
  qaLabel: string,
  isNightMode?: boolean
};

const TrackSelectorButton = ({
  raceNumber,
  openTrackSelector,
  trackSelectorUrl,
  qaLabel,
  isNightMode = false
}: Props) => (
  <Container
    onClick={openTrackSelector}
    to={trackSelectorUrl}
    data-qa-label={`${qaLabel}-container`}
    isNightMode={isNightMode}
  >
    <Text data-qa-label={`${qaLabel}-text`} isNightMode={isNightMode}>
      Race {raceNumber}
    </Text>
    <Icon
      qaLabel={`${qaLabel}-icon`}
      icon={arrowDown}
      color={isNightMode ? buildColor("white") : buildColor("blue")}
      size={20}
    />
  </Container>
);

TrackSelectorButton.defaultProps = {
  raceNumber: "",
  openTrackSelector: noop,
  trackSelectorUrl: "",
  qaLabel: "trackSelectorButton"
};

export default TrackSelectorButton;
